import *  as Icons from '@ant-design/icons';
import { Button, Col, MenuProps, Row, Typography } from 'antd';
import { Layout, Menu } from 'antd';
import { FC, useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';

interface Props {
  children?: JSX.Element[] | JSX.Element
}

const { Header, Content, Sider } = Layout;

type MenuItem = Required<MenuProps>['items'][number];

function getItem(label: React.ReactNode, key: React.Key, icon?: React.ReactNode, children?: MenuItem[],): MenuItem {
  return { key, icon, children, label, } as MenuItem;
}

const items: MenuItem[] = [
  getItem(<Link to="/">داشبورد</Link>, '/', <Icons.PieChartOutlined />),
  getItem(<Link to="/categories-list">دسته ها</Link>, '/categories-list', <Icons.FolderOutlined />,),
  getItem(<Link to="/products-list">محصولات</Link>, '/products-list', <Icons.FileOutlined />,),
  getItem(<Link to="/users-list">کاربران</Link>, '/users-list', <Icons.TeamOutlined />,),
  getItem(<Link to="/credit-packs-list">پکیج ها</Link>, '/credit-packs-list', <Icons.DollarOutlined />,),
  getItem(<Link to="/transactions-list">تراکنش ها</Link>, '/transactions-list', <Icons.SwapOutlined />),
  getItem(<Link to="/images-list">تصاویر</Link>, '/images-list', <Icons.PictureOutlined />,),
  getItem(<Link to="/messages-list">پیام ها</Link>, '/messages-list', <Icons.MessageOutlined />,),
  getItem(<Link to="/orders-list">سفارشات</Link>, '/orders-list', <Icons.ShoppingCartOutlined />,),
  getItem(<Link to="/invoices-list">فاکتور ها</Link>, '/invoices-list', <Icons.CreditCardOutlined />,),
  getItem(<Link to="/adivery-logs-list">ادیوری لاگ</Link>, '/adivery-logs-list', <Icons.FundViewOutlined />),
  getItem(<Link to="/yassocial-services-list">یاس سوشیال</Link>, '/yassocial-services-list', <Icons.InstagramOutlined />),
  getItem(<Link to="/followerma-services-list">فالور ما</Link>, '/followerma-services-list', <Icons.InstagramOutlined />),
  getItem(<Link to="/discounts-list">تخفیف ها</Link>, '/discounts-list', <Icons.PercentageOutlined />),
  getItem(<Link to="/campaigns-list">کمپین ها</Link>, '/campaigns-list', <Icons.PercentageOutlined />),
];

const AdminLayout: FC<Props> = () => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation()
  const navigate = useNavigate()
  return (

    <Layout style={{ minHeight: '100vh' }}>
      <Sider theme='light' collapsible collapsed={collapsed}
        // collapsedWidth={0}
        onCollapse={value => setCollapsed(value)}>
        <div style={{ padding: "20px 24px 12px 0px", height:78 }} >
          {!collapsed && <div>
            <Typography.Title level={5} style={{ margin: 0 }}>کافه فالور</Typography.Title>
            <Typography.Text style={{ margin: 0, color: "#aaaaaa" }}>نسخه 0.1</Typography.Text>
          </div>}
        </div>
        <Menu selectedKeys={[location.pathname]} mode="inline" items={items} />
      </Sider>
      <Layout className="admin-layout">
        <Header style={{ padding: "0 15px" }} >
          <Row wrap={false}>
            <Col flex="auto"></Col>
            <Col flex="none">
              <Button type='primary' onClick={() => navigate('/login')}>خروج</Button>
            </Col>
          </Row>
        </Header>
        <Content style={{ margin: '0 16px' }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}

export default AdminLayout;
